import classNames from "classnames";
import moment from "moment";
import React from "react";
import {
	TBallastRecord,
	EBallastOperationCodes,
} from "../../../../../redux/app/ballast/@types";
import { TBallast_Internal } from "../../../../../redux/app/ballast/groups/internal";
import { commonUtils } from "../../../../../redux/_common";
import CommaSeparator from "../../../../_common/CommaSeparator";
import BallastTableRows from "../_elements/BallastTableRows";

import versions from "../../../../../redux/app/ballast/versions";

type OwnProps = {
	ballastRecord: TBallastRecord;
	isStrikedOff?: boolean;
};
type InternalOperationPreviewProps = OwnProps;
function InternalOperationPreview(props: InternalOperationPreviewProps) {
	const record = props.ballastRecord as TBallast_Internal;
	const operationDate = moment(record.selectedDate, "YYYY-MM-DD").format(
		"DD-MMM-YYYY"
	);

	function renderMain() {
		if (record.version === versions[0].value) {
			if (
				record.operationCode ===
				EBallastOperationCodes.EXCHANGE_INTERNAL_CIRCULATION_MEPC80
			) {
				return (
					<BallastTableRows
						record={record}
						tableRows={[
							[operationDate, "C", "2.1", renderItem2P1()],
							[null, null, "2.2", renderItem2P2()],
							[null, null, "2.3", renderItem2P3()],
							[null, null, "2.4", renderItem2P4()],
							[null, null, "2.5", renderItem2P5()],
							[null, null, "NOTE", record.remarks],
						]}
					/>
				);
			} else {
				return (
					<BallastTableRows
						record={record}
						tableRows={[
							[operationDate, "H", null, renderItemH()],
							[null, null, "NOTE", record.remarks],
						]}
					/>
				);
			}
		} else {
			return (
				<BallastTableRows
					record={record}
					tableRows={[
						[operationDate, null, "3.2.1", renderItem3P2P1()],
						[null, null, "3.2.2", renderItem3P2P2()],
						[null, null, "3.2.3", renderItem3P2P3()],
						[null, null, "NOTE", record.remarks],
					]}
				/>
			);
		}
	}

	// MEPC.369(80)
	function renderItem2P1() {
		const smtStartDate = record.sourceTank.startDate;
		const smtStartTime = record.sourceTank.startTime;
		if (record.timeZone) {
			const dateTimeLocal = `${smtStartDate}T${smtStartTime}:00${record.timeZone}`;
			const utcTime = moment.utc(dateTimeLocal);
			return (
				<>
					{record.placeOfBallast.place === "IN_PORT" ? (
						<>
							Start - {utcTime.format("HH:mm")} hrs (UTC) on{" "}
							{utcTime.format("DD-MMM-YYYY")}, ({smtStartTime} SMT) on{" "}
							{moment(smtStartDate, "YYYY-MM-DD").format("DD-MMM-YYYY")}{" "}
						</>
					) : null}
					{record.placeOfBallast.place === "AT_SEA" ? (
						<>
							Start - {utcTime.format("HH:mm")} hrs (UTC) on{" "}
							{utcTime.format("DD-MMM-YYYY")}, ({smtStartTime} SMT) on{" "}
							{moment(smtStartDate, "YYYY-MM-DD").format("DD-MMM-YYYY")}{" "}
						</>
					) : null}
				</>
			);
		} else {
			return (
				<>
					{record.placeOfBallast.place === "IN_PORT" ? (
						<>
							Start - {record.sourceTank.startTime} hrs (UTC) on{" "}
							{moment(record.sourceTank.startDate, "YYYY-MM-DD").format(
								"DD-MMM-YYYY"
							)}{" "}
						</>
					) : null}
					{record.placeOfBallast.place === "AT_SEA" ? (
						<>
							Start - {record.sourceTank.startTime} hrs (UTC) on{" "}
							{moment(record.sourceTank.startDate, "YYYY-MM-DD").format(
								"DD-MMM-YYYY"
							)}{" "}
						</>
					) : null}
				</>
			);
		}
	}

	function renderItem2P2() {
		const smtEndDate =
			record.destinationTanks[record.destinationTanks.length - 1].endDate;
		const smtEndTime =
			record.destinationTanks[record.destinationTanks.length - 1].endTime;
		if (record.timeZone) {
			const dateTimeLocal = `${smtEndDate}T${smtEndTime}:00${record.timeZone}`;
			const utcTime = moment.utc(dateTimeLocal);
			return (
				<>
					{record.placeOfBallast.place === "IN_PORT" ? (
						<>
							Completion - {utcTime.format("HH:mm")} hrs (UTC) on{" "}
							{utcTime.format("DD-MMM-YYYY")}, ({smtEndTime} SMT) on{" "}
							{moment(smtEndDate, "YYYY-MM-DD").format("DD-MMM-YYYY")}{" "}
						</>
					) : null}
					{record.placeOfBallast.place === "AT_SEA" ? (
						<>
							Completion - {utcTime.format("HH:mm")} hrs (UTC) on{" "}
							{utcTime.format("DD-MMM-YYYY")}, ({smtEndTime} SMT) on{" "}
							{moment(smtEndDate, "YYYY-MM-DD").format("DD-MMM-YYYY")}{" "}
						</>
					) : null}
				</>
			);
		} else {
			return (
				<>
					{record.placeOfBallast.place === "IN_PORT" ? (
						<>
							Completion -{" "}
							{
								record.destinationTanks[record.destinationTanks.length - 1]
									.endTime
							}{" "}
							hrs (UTC) on{" "}
							{moment(
								record.destinationTanks[record.destinationTanks.length - 1]
									.endDate,
								"YYYY-MM-DD"
							).format("DD-MMM-YYYY")}{" "}
						</>
					) : null}
					{record.placeOfBallast.place === "AT_SEA" ? (
						<>
							Completion -{" "}
							{
								record.destinationTanks[record.destinationTanks.length - 1]
									.endTime
							}{" "}
							hrs (UTC) on{" "}
							{moment(
								record.destinationTanks[record.destinationTanks.length - 1]
									.endDate,
								"YYYY-MM-DD"
							).format("DD-MMM-YYYY")}{" "}
						</>
					) : null}
				</>
			);
		}
	}
	function renderItem2P3() {
		return (
			<h4 className="font-medium uppercase">
				<CommaSeparator
					items={[
						...record.destinationTanks.map(
							({ selectedTank, transferQuantity }) =>
								`Volume Circulated ${transferQuantity}M³ from ${record.sourceTank.selectedTank.tankName} to ${selectedTank.tankName}`
						),
					]}
					customSeperator={<br />}
				/>
			</h4>
		);
	}
	function renderItem2P4() {
		return (
			<h4 className="font-medium uppercase">
				{record.sourceTank.transferQuantity}M³ treated through circulation
			</h4>
		);
	}
	function renderItem2P5() {
		return <h4 className="font-medium uppercase">{record.treatmentMethod}</h4>;
	}

	function renderItemH() {
		return (
			<h4 className="font-medium uppercase">
				<CommaSeparator
					items={[
						...record.destinationTanks.map(
							({ selectedTank, transferQuantity }) =>
								`${transferQuantity}M³ of ballast water transferred from ${record.sourceTank.selectedTank.tankName} to ${selectedTank.tankName}`
						),
					]}
					customSeperator={<br />}
				/>
			</h4>
		);
	}
	// MEPC 70
	function renderItem3P2P1() {
		return (
			<h4 className="font-medium uppercase">
				{validatePlaceOfBallastPreview(record)}
			</h4>
		);
	}
	function renderItem3P2P2() {
		return (
			<h4 className="font-medium uppercase">
				<CommaSeparator
					items={[
						...record.destinationTanks.map(
							({ selectedTank, transferQuantity }) =>
								`Volume Circulated ${transferQuantity}M³ from ${record.sourceTank.selectedTank.tankName} to ${selectedTank.tankName}`
						),
					]}
					customSeperator={<br />}
				/>
			</h4>
		);
	}
	function renderItem3P2P3() {
		return (
			<h4 className="font-medium uppercase">
				Yes (Internal transfer between Ballast tanks)
			</h4>
		);
	}

	const validatePlaceOfBallastPreview = (record: TBallast_Internal) => {
		if (record.placeOfBallast) {
			if (record.placeOfBallast.place === "IN_PORT") {
				return (
					<>
						{record.sourceTank.startDate}, {record.sourceTank.startTime} to{" "}
						{
							record.destinationTanks[record.destinationTanks.length - 1]
								.endDate
						}
						,{" "}
						{
							record.destinationTanks[record.destinationTanks.length - 1]
								.endTime
						}{" "}
						at {record.placeOfBallast.portName}
					</>
				);
			} else if (record.placeOfBallast.place === "AT_SEA") {
				return (
					<>
						{record.sourceTank.startDate}, {record.sourceTank.startTime}{" "}
						{record.placeOfBallast.startPosition.latitude},{" "}
						{record.placeOfBallast.startPosition.longitude}, to{" "}
						{
							record.destinationTanks[record.destinationTanks.length - 1]
								.endDate
						}
						,{" "}
						{
							record.destinationTanks[record.destinationTanks.length - 1]
								.endTime
						}{" "}
						{record.placeOfBallast.endPosition.latitude},
						{record.placeOfBallast.endPosition.longitude}
					</>
				);
			}
		} else {
			return (
				<>
					{record.sourceTank.startDate}, {record.sourceTank.startTime} to{" "}
					{record.destinationTanks[record.destinationTanks.length - 1].endDate},{" "}
					{record.destinationTanks[record.destinationTanks.length - 1].endTime}{" "}
				</>
			);
		}
	};

	return renderMain();
}

export default InternalOperationPreview;
